import { motion } from 'framer-motion';

export default function IntegrationsListSection() {
  const crmLogos = [
    {
      name: "Follow Up Boss",
      url: "https://cdn.jsdelivr.net/gh/Pointbreakinc/pbsite@main/FUB.jpg"
    },
    {
      name: "Real Geeks",
      url: "https://cdn.jsdelivr.net/gh/Pointbreakinc/pbsite@main/geek.png"
    },
    {
      name: "Agent Locator",
      url: "https://cdn.jsdelivr.net/gh/Pointbreakinc/pbsite@main/agent.png"
    },
    {
      name: "BoldTrail",
      url: "https://cdn.jsdelivr.net/gh/Pointbreakinc/pbsite@main/bold.png"
    },
    {
      name: "GoHighLevel",
      url: "https://cdn.jsdelivr.net/gh/Pointbreakinc/pbsite@main/GHL.png"
    }
  ];

  return (
    <section className="py-8 sm:py-16 lg:py-24 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      <div className="absolute inset-0 section-pattern opacity-40" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-6 sm:mb-12 lg:mb-16"
        >
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Integrates with your tools
          </h2>
          <p className="text-xl text-gray-600">
            Seamless integration with the CRMs you already use
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-8">
          {crmLogos.map((crm, index) => (
            <motion.div
              key={crm.name}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="flex flex-col items-center"
            >
              <div className="bg-white border-2 border-gray-200 rounded-2xl p-4 sm:p-6 w-full h-24 sm:h-auto sm:aspect-square flex items-center justify-center shadow-md hover:shadow-xl hover:border-[#d4a10d]/30 transition-all duration-300 card-tilt">
                <img
                  src={crm.url}
                  alt={crm.name}
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <p className="text-sm text-gray-700 mt-2 sm:mt-4 text-center font-semibold">
                {crm.name}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          viewport={{ once: true }}
          className="mt-6 sm:mt-12 lg:mt-16 text-center"
        >
          <p className="text-lg text-gray-700 font-medium">
            Don't see yours? <span className="text-[#d4a10d] font-semibold">We can integrate with most systems.</span>
          </p>
        </motion.div>
      </div>
    </section>
  );
}

